export const actionPages = {
  AUTH: 'אימות',
  ORDER_INVOICE: 'הזמנת חשבונית',
  PAYMENT: 'סליקה באשראי',
  INVITE_FRIEND: 'מבצע חבר מביא חבר',
  SETTINGS: 'הגדרות',
}